interface LoadingSpinnerProps {
  message?: string
  fullScreen?: boolean
  size?: 'sm' | 'md' | 'lg'
  className?: string
}

const LoadingSpinner = ({ 
  message = 'Loading...', 
  fullScreen = false,
  size = 'md',
  className = ''
}: LoadingSpinnerProps) => {
  // Size variants
  const sizeClasses = {
    sm: 'h-8 w-8',
    md: 'h-10 w-10',
    lg: 'h-12 w-12'
  }

  const spinnerSize = sizeClasses[size]

  // Full screen layout
  if (fullScreen) {
    return (
      <div className="min-h-screen bg-white flex items-center justify-center">
        <div className="text-center">
          <div className={`inline-block animate-spin rounded-full border-b-2 border-wine-100 ${spinnerSize}`}></div>
          {message && (
            <p className="mt-4 text-gray-600 font-satoshi">{message}</p>
          )}
        </div>
      </div>
    )
  }

  // Inline layout
  return (
    <div className={`text-center py-12 ${className}`}>
      <div className={`inline-block animate-spin rounded-full border-b-2 border-wine-100 ${spinnerSize}`}></div>
      {message && (
        <p className="mt-4 text-gray-500 font-satoshi">{message}</p>
      )}
    </div>
  )
}

export default LoadingSpinner

